// extracted by mini-css-extract-plugin
module.exports = {"deleteCell":"deleteCell__KCRWO","iconButton":"iconButton__1snJl"};